<template>
  <div style="background: orange; padding: 20px; border: 3px solid red;">
    <h1>NEW COMPONENT WORKS!</h1>
  </div>
</template>

<script>
export default {
  name: 'Model3DViewerNew',
  mounted() {
    console.log('🎉🎉🎉 NEW COMPONENT MOUNTED!');
  }
};
</script>
